/**
 * rightSectionCore.js — КАК ОТКРЫВАТЬ РАЗДЕЛ ПРАВОГО САЙДБАРА КНОПКОЙ
 * ВЕРХНЕГО МЕНЮ. [12.0.25]
 *
 * Чистый модуль, без DOM: решения, которые можно проверить арифметикой.
 * Проводка — rightSection.js.
 *
 * Откуда взялось. Раздел RT (12.0.16) показывал, что открыт, постоянным
 * жёлтым переливом по краю — и был единственным таким: «Качество», «Отчёты»
 * и прочие не переливались. Владелец: «я лишь хочу не переливы, а чтобы
 * пользователь при нажатии на кнопку RT видел, что необходимый ему раздел
 * открылся справа». То есть нужен сигнал В МОМЕНТ открытия, а не вечная
 * анимация на краю зрения, пока врач смотрит снимок.
 *
 * Правило одно на все разделы, которые открываются кнопкой сверху (сейчас
 * это RT и «Качество КТ/МРТ»): открыть сайдбар, если закрыт; сделать
 * вкладку активной; прокрутить раздел к началу; один раз коротко отметить
 * раздел и его вкладку.
 *
 * EXPORTS: ОТМЕТКА_МС, ВЫЕЗД_МС, планОткрытия, кнопкаГорит
 */

/**
 * Сколько горит отметка. Должно совпадать с длительностью анимаций
 * tabArriveFrame / tabArriveTab в index.html (1.5s) — проверяется
 * verify_12_0_25. Подобрано на глаз: заметно боковым зрением, но гаснет
 * раньше, чем начинает мешать.
 */
export const ОТМЕТКА_МС = 1500;

/**
 * Сколько выезжает сайдбар (transition: transform 0.3s у .sidebar-right).
 * Если сайдбар был закрыт, отметка ждёт конца выезда: вспышка на панели,
 * которая ещё едет, половиной длительности проходит мимо глаз.
 */
export const ВЫЕЗД_МС = 300;

/**
 * Что сделать, чтобы открыть раздел.
 *
 * @param {object} с
 * @param {boolean} с.узкий — экран ≤768 px: правого сайдбара нет вовсе
 * @param {boolean} с.сайдбарОткрыт
 * @returns {{действовать:boolean, открытьСайдбар?:boolean, прокрутитьВверх?:boolean,
 *            отметка?:boolean, задержкаМс?:number}}
 */
export function планОткрытия({ узкий, сайдбарОткрыт } = {}) {
  // На телефоне раздел показывают по-своему (RT — плавающей панелью,
  // «Качество» — листом во весь экран): открывать нечего, отмечать нечего.
  if (узкий) return { действовать: false };
  const открыть = !сайдбарОткрыт;
  return {
    действовать: true,
    открытьСайдбар: открыть,
    // Тело вкладок прокручивается одно на все разделы: без сброса раздел
    // открывался бы на той глубине, где врач оставил ПРЕДЫДУЩИЙ, — с
    // середины, без заголовка, и отметка подсветила бы непонятно что.
    прокрутитьВверх: true,
    отметка: true,
    задержкаМс: открыть ? ВЫЕЗД_МС : 0,
  };
}

/**
 * Горит ли кнопка верхнего меню, открывшая раздел: да, пока её раздел на
 * виду. Считается по СОСТОЯНИЮ (сайдбар открыт, вкладка активна), а не по
 * щелчкам: прежняя подсветка RT слушала щелчок по кнопке сайдбара, а тот
 * обработчик в htmlInit.js глушит событие (stopImmediatePropagation) — закрыл
 * сайдбар его же кнопкой, и RT оставалась гореть.
 *
 * @param {object} с
 * @param {boolean} с.сайдбарОткрыт
 * @param {string|null} с.активнаяВкладка — id активного .tab-panel
 * @param {string} с.раздел — id раздела этой кнопки
 */
export function кнопкаГорит({ сайдбарОткрыт, активнаяВкладка, раздел } = {}) {
  return !!(сайдбарОткрыт && раздел && активнаяВкладка === раздел);
}
